import { commonBatchPrintingDashboardService } from '@/api/services/common/batch-printing-dashboard/batch-printing-dashboard.service'
import { DashboardModuleLayoutWidget } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { DashboardModuleSharedWidgetsPrintLabelsState, initialDashboardModuleSharedWidgetsPrintLabelsState } from '@/modules/dashboard-module/shared/widgets/print-labels-widget/dashboard-module-shared-widgets-print-labels-widget.model'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { store } from '@/store/store'
import { Vue, Prop, Component, Ref } from 'vue-property-decorator'
import PrintLabelsModal from '@/components/modals/printLabelsModal/PrintLabelsModal.vue'
import { ReportModelEnum } from '@/modules/printModule/services/report-model-configuration/report-model-configuration.model'
@Component({
    components: {
        PrintLabelsModal
    }
})
export default class DashboardModuleSharedWidgetsPrintLabelsWidget extends Vue {
    @Ref() readonly printLabelsModal!: any
    @Prop(Object) readonly widgetData!: DashboardModuleLayoutWidget

    state: DashboardModuleSharedWidgetsPrintLabelsState
    constructor() {
        super()
        this.state = initialDashboardModuleSharedWidgetsPrintLabelsState()
    }

    async mounted(): Promise<void> {
        await this.getPrintingTemplates()
    }

    get isLoading(): boolean {
        return this.state.loading
    }

    get colorWidget(): string {
        return this.widgetData?.color ?? ''
    }

    get templatesExists(): boolean {
        return !!this.state.templates.list.length
    }

    get entitySelected(): string {
        return this.state.templates.selected?.batchPrinting.caseType.description ?? ''
    }

    get isRangePrinting(): boolean {
        return !!this.state.templates.selected?.batchPrinting.rangeLabel
    }

    get rangePrinting(): string {
        return this.isRangePrinting ? `${this.state.templates.selected?.batchPrinting.minValue} - ${this.state.templates.selected?.batchPrinting.maxValue}` : `${this.state.templates.selected?.batchPrinting.numberOfNextLabels}`
    }

    get hasCaseLabel(): boolean {
        return !!this.state.templates.selected?.batchPrinting.reportModelsList.includes(ReportModelEnum.CASE_LABEL)
    }

    get hasSampleLabel(): boolean {
        return !!this.state.templates.selected?.batchPrinting.reportModelsList.includes(ReportModelEnum.SAMPLE_LABEL)
    }

    get hasCasseteParaffinBlockPortionLabel(): boolean {
        return !!this.state.templates.selected?.batchPrinting.reportModelsList.includes(ReportModelEnum.CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL)
    }

    get hasSubportionSlideLabel(): boolean {
        return !!this.state.templates.selected?.batchPrinting.reportModelsList.includes(ReportModelEnum.SUBPORTION_SLIDE_LABEL)
    }

    async removeWidget(): Promise<void> {
        await store.dispatch('dashboard/removeWidgetAndSetVisible', this.widgetData)
    }

    showPrintLabelsModal(): void {
        this.printLabelsModal.show(this.state.templates.selected)
    }

    async getPrintingTemplates(): Promise<void> {
        this.state.loading = true
        const response = await PromiseUtils.toCallSecure(commonBatchPrintingDashboardService.getBatchPrintingTemplatesByLaboratory(store.getters.labId))
        this.state.templates.list = response ?? []
        if (this.state.templates.list.length) {
            const defaultTemplate = this.state.templates.list.find((item) => item.toBeUsedByDefault)
            this.state.templates.selected = defaultTemplate ?? this.state.templates.list[0]
        } else {
            this.state.templates.selected = null
        }
        this.state.loading = false
    }
}
